import { APPOINTMENT_STATUS_LABELS, type AppointmentStatusValue } from '@crm/shared';
import { Badge } from '@crm/ui';

const VARIANT: Record<
  AppointmentStatusValue,
  'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline'
> = {
  SCHEDULED: 'secondary',
  CONFIRMED: 'default',
  IN_PROGRESS: 'warning',
  COMPLETED: 'success',
  CANCELLED: 'destructive',
  NO_SHOW: 'outline',
};

export function AppointmentStatusBadge({ status }: { status: AppointmentStatusValue }) {
  return <Badge variant={VARIANT[status]}>{APPOINTMENT_STATUS_LABELS[status]}</Badge>;
}
